import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const santanderLandscapeRedLogoOutro = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const nameElement = findElementByName(elements, ELEMENT_NAMES.NAME);
  const titleElement = findElementByName(elements, ELEMENT_NAMES.TITLE);
  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);
  const redLogoOutroElement = findElementByName(elements, ELEMENT_NAMES.RED_LOGO_OUTRO);
  const nameAndTitleOverlayElement = findElementByName(elements,
    ELEMENT_NAMES.NAME_AND_TITLE_OVERLAY);

  const ANIMATION_TIME_OUTRO = (storyVideoElement?.duration - redLogoOutroElement?.time);
  const RED_LOGO_OUTRO_DURATION = redLogoOutroElement?.duration ?? 0;
  const NAME_START_TIME = nameElement?.time ?? 0;
  const NAME_TITLE_DURATION = (titleElement?.duration + NAME_START_TIME);

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    x: storyVideoElement?.x,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    border_radius: storyVideoElement?.border_radius,
    animations: storyVideoElement?.animations
  }, 0);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);

  const modifications = {
    [`${nameElement?.id}.text`]: story?.creator?.name,
    [`${titleElement?.id}.text`]: story?.creator?.title || "",
    [`${redLogoOutroElement?.id}.time`]: videoDuration - ANIMATION_TIME_OUTRO,
    duration: videoDuration + RED_LOGO_OUTRO_DURATION - ANIMATION_TIME_OUTRO
  };

  if (videoDuration < NAME_TITLE_DURATION) {
    // We need to sustract the time that it will take the name to appear
    const newDuration = Math.max(videoDuration - NAME_START_TIME, 0);
    modifications[`${nameElement?.id}.duration`] = newDuration;
    modifications[`${titleElement?.id}.duration`] = newDuration;
    modifications[`${nameAndTitleOverlayElement?.value}.duration`] = newDuration;
  }
  await preview.applyModifications(modifications);
};

export default santanderLandscapeRedLogoOutro;
